import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import slider1 from '../../../assets/Login/Group 4.png'
import slider2 from '../../../assets/Login/Rectangle 20.png'
import slider3 from '../../../assets/Login/Rectangle 23.png'
import slider4 from '../../../assets/Login/banner_base.png'

function LoginSlider() {

  const settings = {
    dots: true,
    lazyLoad: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 2,
    arrows:false,
    autoplay:true
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        <div>
          <img src={slider1 } className="w-100" />
        </div>
        <div>
          <img src={slider2}  className="w-100" />
        </div>
        <div>
          <img src={slider3 }  className="w-100" />
        </div>
        <div>
          <img src={slider4 }  className="w-100 rounded-5" />
        </div>
      </Slider>
    </div>
  );
}

export default LoginSlider;
